import { FC, HTMLProps, PropsWithChildren } from 'react';
import { StyledCard } from './Card.styles';

export interface CardProps
  extends PropsWithChildren<HTMLProps<HTMLDivElement>> {
  /** Card fills its container */
  $fullWidth?: boolean;
}

/**
A simple card container
*/
export const Card = StyledCard as FC<CardProps>;

export default Card;
